var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemoveTaskHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4615 3.88462H0.846154C0.378836 3.88462 0 4.26345 0 4.73077C0 5.19809 0.378836 5.57692 0.846154 5.57692H19.4615C19.9289 5.57692 20.3077 5.19809 20.3077 4.73077C20.3077 4.26345 19.9289 3.88462 19.4615 3.88462Z",
    fill: "#5932EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76923 9.80769V16.5769C6.76923 17.0442 7.14807 17.4231 7.61539 17.4231C8.0827 17.4231 8.46154 17.0442 8.46154 16.5769V9.80769C8.46154 9.34037 8.0827 8.96154 7.61539 8.96154C7.14807 8.96154 6.76923 9.34037 6.76923 9.80769Z",
    fill: "#5932EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8462 9.80769V16.5769C11.8462 17.0442 12.225 17.4231 12.6923 17.4231C13.1596 17.4231 13.5385 17.0442 13.5385 16.5769V9.80769C13.5385 9.34037 13.1596 8.96154 12.6923 8.96154C12.225 8.96154 11.8462 9.34037 11.8462 9.80769Z",
    fill: "#5932EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38462 20.8077V4.73077C3.38462 4.26345 3.00578 3.88462 2.53846 3.88462C2.07114 3.88462 1.69231 4.26345 1.69231 4.73077V20.8077C1.69231 21.5087 2.18797 22.0043 2.18797 22.0043C2.68364 22.5 3.38462 22.5 3.38462 22.5H16.9231C17.6241 22.5 18.1197 22.0043 18.1197 22.0043C18.6154 21.5087 18.6154 20.8077 18.6154 20.8077V4.73077C18.6154 4.26345 18.2365 3.88462 17.7692 3.88462C17.3019 3.88462 16.9231 4.26345 16.9231 4.73077V20.8077H3.38462Z",
    fill: "#5932EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82042 1.2435C5.07692 1.987 5.07692 3.03846 5.07692 3.03846V4.73077C5.07692 5.19809 5.45576 5.57692 5.92308 5.57692C6.3904 5.57692 6.76923 5.19809 6.76923 4.73077V3.03846C6.76923 2.68797 7.01706 2.44014 7.01706 2.44014C7.2649 2.19231 7.61539 2.19231 7.61539 2.19231H12.6923C13.0428 2.19231 13.2906 2.44014 13.2906 2.44014C13.5385 2.68797 13.5385 3.03846 13.5385 3.03846V4.73077C13.5385 5.19809 13.9173 5.57692 14.3846 5.57692C14.8519 5.57692 15.2308 5.19809 15.2308 4.73077V3.03846C15.2308 1.987 14.4873 1.2435 14.4873 1.2435C13.7438 0.5 12.6923 0.5 12.6923 0.5H7.61539C6.56392 0.5 5.82042 1.2435 5.82042 1.2435Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveTaskHover);
export default __webpack_public_path__ + "static/media/remove-task-hover.03679bdfa3a6839e43e3b0625dcf889f.svg";
export { ForwardRef as ReactComponent };